module.exports = __webpack_public_path__ + "static/tw-grid-tab-2e0897989923b5b8c91ed60f1e5ced4c.jpg";